import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function ArbLockedGate() {
  return (
    <div
      className="border border-amber-500/40 bg-amber-500/5 p-10 text-center"
      data-testid="arb-locked"
    >
      <Lock size={28} strokeWidth={1.5} className="text-amber-400 mx-auto mb-4" />
      <div className="font-display text-2xl amber-text mb-2">
        Pro subscription required
      </div>
      <p className="text-sm text-zinc-300 max-w-md mx-auto mb-6">
        The arbitrage scanner is a Pro feature. Start your 3-day free trial and get
        it, plus unlimited research and the morning email digest.
      </p>
      <Link
        to="/app/billing"
        data-testid="arb-to-billing"
        className="inline-flex items-center gap-2 px-6 py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs"
      >
        Start 3 Free Days
      </Link>
    </div>
  );
}
